import {queryClient} from '@/query/queryClient.js'
import {StylesSettings} from "@/types/stylesSettings";
import { $axiosCustomization } from '@/api'

export default {
    state: {
        customInformation: {}
    },
    mutations: {
        setInfo(state, value) {
            state.customInformation = new StylesSettings(value)
        }
    },
    getters: {
        /**
         * @return {StylesSettings}
         */
        getCustomInformation: state => state.customInformation
    },
    actions: {
        async fetchCustomInfo({commit}) {
            try {
                const data = await queryClient.fetchQuery({
                    queryKey: ['customInformation'],
                    queryFn: async () => {
                        const resp = await $axiosCustomization()
                        if (!resp.data) throw new Error('Customization data not found')

                        return resp.data
                    }
                })
                commit('setInfo', data)
            } catch (err) {
                console.log('Failed to fetch custom info:', err)
            }
        }

    }
}
